// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldTooltipBadge_wrapper__r6xrQ","badge":"FieldTooltipBadge_badge__zGrCh"};